import { render, staticRenderFns } from "./ListaBancos.vue?vue&type=template&id=2b7edd17&"
import script from "./ListaBancos.vue?vue&type=script&lang=js&"
export * from "./ListaBancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports